import { useDispatch } from "../../redux/hooks";
import { setEditing } from "../../redux/slices/entrySlice";

export const useTriggerAutoSave = () => {
  const dispatch = useDispatch();
  return () => {
    dispatch(setEditing(false));
    setTimeout(() => dispatch(setEditing(true)), 0);
  };
};
